export default "__VITE_ASSET__Bm7sdE_1__"